// Matches any string that begins with `//` or `http` or other native links like`maps:`, `mailto:`, `sms:` or `tel:`
const externalLinkRegex = /^(\/{2}|http|[a-z]+:)/;

export const isExternalLink = (url: string | null = '') => !!url && externalLinkRegex.test(url);
